import React from 'react';

import styles from './step-drawer.module.scss';
export const BlocContent = ({ className, ...props }: React.ComponentPropsWithoutRef<'p'>) => (
  <p
    className={className ? `${styles['bloc-content']} ${className}` : styles['bloc-content']}
    {...props}
  />
);

export const Bloc = ({ className, ...props }: React.ComponentPropsWithoutRef<'div'>) => (
  <div className={className ? `${styles['bloc']} ${className}` : styles['bloc']} {...props} />
);
